import React, { useEffect } from "react";
import { useLocation } from "react-router";
import "./AboutUs.css";

import Achievements from "./Achievements";
import AboutBanner from "./AboutBanner";
import SisterConcerms from "./SisterConcerms";

const AboutUs = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        const handleScroll = () => {
          const navbarOffset = 100;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - navbarOffset;
          window.scrollTo({ top: offsetPosition, behavior: "smooth" });
        };
        setTimeout(handleScroll, 300);
      }
    }
  }, [location]);

  const services = [
    "Transportation", "Real Estate", "Digital Solutions", "Software & IT",
    "Furniture Manufacturing", "Travel & Tourism", "Hajj & Umrah Services",
    "Education & Skills", "Automotive Engineering", "GPS Tracking",
    "Logistics", "International Business"
  ];

  const valuePoints = [
    "Diversified platform with a long-term vision",
    "Strong commitment to innovation",
    "Professional management support",
    "Transparent corporate governance",
    "Sustainable business models",
    "Customer-centric approach"
  ];

  return (
    <div className="about-container">
      {/* 1. Banner */}
      <AboutBanner
        text={"ABOUT US"}
        des={"Building Businesses. Empowering Futures."}
      />

      <div className="about-content-wrapper">



        {/* 2. Intro Section */}
        <section style={{
          display: "flex",
          alignItems: "center",
          gap: "40px",
          maxWidth: "1440px",
          margin: "0 auto 60px auto",
          flexWrap: "wrap"
        }}>
          {/* Left Content */}
          <div style={{ flex: "1 1 450px" }}>

            <h2 style={{ fontSize: "2.25rem", fontWeight: "700", color: "#0f172a", marginBottom: "16px", letterSpacing: "-0.02em" }}>
              Our Visionary Journey
            </h2>
            <p style={{ fontSize: "1.125rem", color: "#232529c0", lineHeight: "1.8", }}>
              <strong style={{ color: "#0f172a" }}>Iconic Unity Group (IUG)</strong> is a diversified business platform established on <strong style={{ color: "#0f172a" }}>03 April 2024</strong>,
              driven by a vision to empower entrepreneurs, build sustainable businesses, and create long-term value for society.
              Founded by five visionary entrepreneurs, IUG was created on the belief that collaboration, innovation, and shared leadership
              can build stronger businesses than individual efforts alone.
            </p>
          </div>

          {/* Right Image */}
          <div style={{ flex: "1 1 450px" }}>
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"
              alt="Our Visionary Journey"
              style={{
                width: "100%",
                height: "360px",
                objectFit: "cover",
                borderRadius: "16px",
                boxShadow: "0 10px 25px -5px rgba(15, 23, 42, 0.1)",
                border: "1px solid #e2e8f0"
              }}
            />
          </div>
        </section>

        {/* 3. Who We Are & Purpose Section */}
        <section style={{ display: "flex", flexWrap: "wrap", gap: "32px", alignItems: "stretch", maxWidth: "1440px", margin: "0 auto" }}>
          <div style={{
            flex: "1 1 350px",
            backgroundColor: "#f8fafc",
            padding: "48px",
            borderRadius: "20px",
            border: "1px solid #e2e8f0",
            marginBottom: "40px",
          }}>
            <h3 style={{ fontSize: "1.75rem", color: "#000000", marginBottom: "16px" }}>Who We Are</h3>
            <p style={{ color: "#232529c0", fontSize: "1.05rem", lineHeight: "1.7", margin: 0 }}>
              Iconic Unity Group is more than a corporate group we are a business platform for entrepreneurs, innovators, and business leaders.
              Unlike a traditional group, IUG operates as a unified corporate framework that brings together professionals and strategic partners.
              We provide strategic guidance, professional management, and shared resources to help businesses grow sustainably.
            </p>
          </div>
          <div style={{
            flex: "1 1 350px",
            backgroundColor: "#f8fafc",
            padding: "48px",
            borderRadius: "20px",
            border: "1px solid #e2e8f0",
            marginBottom: "40px",
          }}>
            <h4 style={{ fontSize: "1.5rem", marginBottom: "16px", color: "#000000", marginTop: 0 }}>Our Purpose</h4>
            <p style={{ fontSize: "1.05rem", color: "#232529c0", lineHeight: "1.7", margin: 0 }}>
              To create a collaborative business ecosystem where entrepreneurs receive strategic support to build successful businesses
              through innovation and responsible leadership.
            </p>
          </div>
        </section>

        {/* 4. What We Do Section */}
        <section style={{ maxWidth: "1440px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "48px" }}>
            <h3 style={{ fontSize: "2.25rem", fontWeight: "700", color: "#0f172a", marginBottom: "16px", letterSpacing: "-0.02em" }}>
              What We Do
            </h3>
            <p style={{ fontSize: "1.1rem", color: "#232529c0", margin: 0 }}>
              Operating and supporting businesses across a wide range of industries
            </p>
          </div>
          <div style={{
            display: "grid",
            // gridTemplateColumns: "repeat(6, minmax(140px, 1fr))",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px"
          }}>
            {services.map((item, index) => (
              <div
                key={index}
                style={{
                  padding: "20px 10px",
                  backgroundColor: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  textAlign: "center",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                  cursor: "default"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.borderColor = "#2563eb";
                  e.currentTarget.style.backgroundColor = "#f8fafc";
                  const span = e.currentTarget.querySelector("span");
                  if (span) span.style.color = "#2563eb";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  const span = e.currentTarget.querySelector("span");
                  if (span) span.style.color = "#0f172a";
                }}
              >
                <span style={{ fontWeight: "600", color: "#0f172a", fontSize: "1rem", transition: "color 0.3s ease" }}>
                  {item}
                </span>
              </div>
            ))}
          </div>
        </section>

        {/* 5. Why Choose Us Section */}
        <section style={{

          // backgroundColor: "#f8fafc",
          padding: "60px 0px",
          // borderRadius: "24px",
          // border: "1px solid #e2e8f0",
          maxWidth: "1440px", margin: "0 auto"
        }}>
          <h3 style={{ fontSize: "2.25rem", fontWeight: "700", color: "#0f172a", textAlign: "center", marginBottom: "48px", letterSpacing: "-0.02em" }}>
            Why Iconic Unity Group?
          </h3>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
            gap: "24px"
          }}>
            {valuePoints.map((text, i) => (
              <div key={i} style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                backgroundColor: "#ffffff",
                padding: "20px",
                borderRadius: "12px",
                border: "1px solid #e2e8f0",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
              }}>
                <div style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "#dcfce7",
                  color: "#16a34a",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                  flexShrink: 0
                }}>
                  ✓
                </div>
                <p style={{ margin: 0, fontWeight: "500", color: "#1e293b" }}>{text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 6. Our Promise (Quote Section) */}
        <section style={{
          position: "relative",
          backgroundColor: "#ffffff",
          // padding: "80px 40px",
          // borderRadius: "24px",
          color: "#000000",
          textAlign: "center",
          // boxShadow: "0 20px 30px -10px rgba(15, 23, 42, 0.12)",
          overflow: "hidden",
          maxWidth: "1440px", margin: "0 auto"
        }}>
          <div style={{ marginBottom: "40px", }}>
            <h2 style={{ fontSize: "2.5rem", marginBottom: "24px", letterSpacing: "-0.01em", marginTop: 0, fontWeight: "600" }}>
              Our Promise
            </h2>
            <blockquote style={{
              fontSize: "1.35rem",
              maxWidth: "850px",
              margin: "0 auto",
              fontWeight: "300",
              lineHeight: "1.7",
              color: "#232529c7"
            }}>
              "At Iconic Unity Group, we believe that when entrepreneurs unite with the right vision, resources, and leadership,
              businesses thrive, communities prosper, and the future becomes stronger for everyone."
            </blockquote>
          </div>
        </section>


        {/* 7. Existing Components */}
        <Achievements />
        <SisterConcerms />

      </div>
    </div>
  );
};

export default AboutUs;